"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Item = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _models = require("../../models");
var _Description = require("./Description");
var _Image = require("./Image");
var _SelectedIcon = require("./SelectedIcon");
var _sharedStyles = require("./sharedStyles");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)(_mui.Box)((param)=>{
    let { ownerState: { isDisabled, isDoubleCurrency, isSelected }, theme } = param;
    return {
        cursor: 'pointer',
        ...(0, _sharedStyles.itemStyles)(isDoubleCurrency, theme),
        ...isSelected && {
            border: "1px solid ".concat(theme.palette.grey.A400)
        },
        ...isDisabled && {
            opacity: 0.5
        }
    };
});
const ImageWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return (0, _sharedStyles.imageStyles)(theme);
});
const Item = (props)=>{
    const { isDoubleCurrency } = (0, _contexts.useCheckoutDeliveryContext)();
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { description, isDisabled, onToggleItem, productCode, productImageUrl, selectedQuantity } = props;
    // For now, selecting an item means setting its quantity to 1.
    // Later, we might want to introduce quantity picker for higher quantities.
    const isSelected = selectedQuantity > 0;
    // Prices should be formatted already from server in shipping offer data.
    // The isDoubleCurrency configuration property is used only for layout purposes.
    const ownerState = {
        isDisabled,
        isDoubleCurrency,
        isSelected
    };
    const shippingOfferTestId = "".concat(_models.TestId.ShippingOfferItem, "-").concat(productCode);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        ownerState: ownerState,
        onClick: onToggleItem,
        ...getTestIdProps(shippingOfferTestId),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SelectedIcon.SelectedIcon, {
                isSelected: isSelected,
                ...getTestIdProps(_models.TestId.SelectedIcon)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Image.ItemImage, {
                    name: description,
                    src: productImageUrl
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Description.Description, {
                ...props,
                isDoubleCurrency: isDoubleCurrency,
                ...getTestIdProps(_models.TestId.ItemDescription)
            })
        ]
    });
};
exports.Item = Item;
